import { SuggestionBucket } from './suggestions.types';

export const MAX_SUGGESTIONS_PER_GROUP = 5;

export const SUGGESTION_GROUP_LABELS: Record<SuggestionBucket, string> = {
  [SuggestionBucket.SameRequester]: 'Same requester',
  [SuggestionBucket.CurrentlyOpened]: 'Currently opened',
};
